export const isDisabled = (enabledSteps, step) =>
    enabledSteps.indexOf(step) < 0;
